import { VEHICLE_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';
import { paramsToQueryString } from '../../../utility/helpers/commonFunction';

/**
 * Get vehicle list for a customer
 * @param {object} params - Query parameters
 * @param {string} params.customerId - Customer ID
 * @param {number} params.page - Page number
 * @param {number} params.limit - Number of items per page
 * @returns {Promise} - Array of vehicle objects
 */
export const getVehicleListApi = async (params = {}) => {
    let queryParameter = paramsToQueryString(params);
    const response = await instance.get(VEHICLE_ROUTES.GET_VEHICLE_LIST + queryParameter);
    return response.data.data || response.data;
};

/**
 * Get vehicle details by ID
 * @param {string} vehicleId - Vehicle ID
 * @returns {Promise} - Vehicle object
 */
export const getVehicleDetailsApi = async (vehicleId) => {
    const response = await instance.get(VEHICLE_ROUTES.GET_VEHICLE_DETAILS.replace(':vehicleId', vehicleId));
    return response.data.data || response.data;
};

/**
 * Create a new vehicle
 * @param {object} vehicleData - Vehicle data
 * @param {string} vehicleData.customerId - Customer ID
 * @param {string} vehicleData.year - Vehicle year
 * @param {string} vehicleData.vehicleMakeId - Vehicle make ID
 * @param {string} vehicleData.vehicleModelId - Vehicle model ID
 * @param {string} vehicleData.vehicleModelTrimId - Vehicle trim ID (optional)
 * @param {string} vehicleData.vin - VIN number (optional)
 * @param {string} vehicleData.licenseNumber - License plate number (optional)
 * @param {string} vehicleData.provinceId - Province ID (optional)
 * @param {string} vehicleData.fleetUnitNumber - Fleet unit number (optional)
 * @returns {Promise} - Created vehicle object
 */
export const createVehicleApi = async (vehicleData) => {
    const response = await instance.post(VEHICLE_ROUTES.CREATE_VEHICLE, vehicleData);
    return response.data;
};

/**
 * convert an existing vehicle from shop_imported to shop created
 * @param {string} vehicleId - Vehicle ID
 * @returns {Promise} - created vehicle object
 */

export const createImportedVehicleApi = async (vehicleId, vehicleData) => {
    const response = await instance.post(VEHICLE_ROUTES.ADD_IMPORTED_VEHICLE(vehicleId), vehicleData);
    return response.data;
};

/**
 * Update an imported vehicle
 * @param {string} vehicleId - Vehicle ID
 * @param {object} vehicleData - Updated vehicle data
 * @returns {Promise} - Updated vehicle object
 */
export const updateImportedVehicleApi = async (vehicleId, vehicleData) => {
    const response = await instance.put(VEHICLE_ROUTES.UPDATE_IMPORTED_VEHICLE(vehicleId), vehicleData);
    return response.data;
};

/**
 * Delete an imported vehicle
 * @param {string} vehicleId - Vehicle ID
 * @returns {Promise} - Success response
 */
export const deleteImportedVehicleApi = async (vehicleId) => {
    const response = await instance.delete(VEHICLE_ROUTES.DELETE_IMPORTED_VEHICLE(vehicleId));
    return response.data;
};

/**
 * Update an existing vehicle
 * @param {string} vehicleId - Vehicle ID
 * @param {object} vehicleData - Updated vehicle data
 * @returns {Promise} - Updated vehicle object
 */
export const updateVehicleApi = async (vehicleId, vehicleData) => {
    const response = await instance.put(VEHICLE_ROUTES.UPDATE_VEHICLE + vehicleId, vehicleData);
    return response.data;
};

/**
 * Delete a vehicle
 * @param {string} vehicleId - Vehicle ID
 * @returns {Promise} - Success response
 */
export const deleteVehicleApi = async (vehicleId) => {
    const response = await instance.delete(VEHICLE_ROUTES.DELETE_VEHICLE + vehicleId);
    return response.data;
};
